import { Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { AuthService } from "../../../shared/service/auth-service/auth-service.service";
import { ListDataColumn } from "../../../shared/ui/Data/ListColumn";
import { OperatorEnum } from "../../../shared/ui/OperatorUtil";
import { LABELSTYLE } from "../../../shared/ui/Constants";

export class FieldDefinition {

  constructor(private injector: Injector) { }

  socFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'code',
      type: 'input',
      props: {
        disabled: true,
        label: 'SOC Code'
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'input',
      props: {
        disabled: true,
        label: 'SOC Name'
      }
    },
    {
      className: 'flex-1',
      key: 'abbreviation',
      type: 'input',
      props: {
        disabled: true,
        label: 'SOC Abbrev'
      }
    }
  ];

  socQueryFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'fieldQueryType',
      props: {
        label: 'SOC Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'fieldQueryType',
      props: {
        label: 'SOC Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT
      }
    }, {
      className: 'flex-1',
      key: 'abbreviation',
      type: 'fieldQueryType',
      props: {
        label: 'SOC Abbreviation',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT
      }
    }, {
      className: 'flex-1',
      key: 'numHLGT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of HLGT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }, {
      className: 'flex-1',
      key: 'numHLT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of HLT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }, {
      className: 'flex-1',
      key: 'numPT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of PT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }, {
      className: 'flex-1',
      key: 'numLLT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of LLT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    },
  ];

  hlgtQueryFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'fieldQueryType',
      props: {
        label: 'HLGT Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'fieldQueryType',
      props: {
        label: 'HLGT Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT
      }
    }, {
      className: 'flex-1',
      key: 'numHLT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of HLT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }, {
      className: 'flex-1',
      key: 'numPT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of PT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }, {
      className: 'flex-1',
      key: 'numLLT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of LLT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }
  ];

  hltQueryFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'fieldQueryType',
      props: {
        label: 'HLT Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'fieldQueryType',
      props: {
        label: 'HLT Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT
      }
    }, {
      className: 'flex-1',
      key: 'numPT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of PT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }, {
      className: 'flex-1',
      key: 'numLLT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of LLT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }
  ];

  ptQueryFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'fieldQueryType',
      props: {
        label: 'PT Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'fieldQueryType',
      props: {
        label: 'PT Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT
      }
    }, {
      className: 'flex-1',
      key: 'numLLT',
      type: 'fieldQueryType',
      props: {
        label: 'Number of LLT Terms',
        defaultSelection: false,
        fieldDataType: ListDataColumn.NUMBER
      },
      hideExpression: () => {
        return !this.injector.get(AuthService).isEMAOrganisation();
      }
    }
  ];

  lltQueryFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'num',
      type: 'fieldQueryType',
      hide: true,
      props: {
        label: 'Num',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'fieldQueryType',
      props: {
        label: 'LLT Code',
        defaultSelection: true,
        fieldDataType: ListDataColumn.NUMBER
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'fieldQueryType',
      props: {
        label: 'LLT Name',
        defaultSelection: true,
        fieldDataType: ListDataColumn.TEXT
      }
    }, {
      className: 'flex-1',
      key: 'lltDeprecated',
      type: 'fieldQueryType',
      props: {
        label: 'Is Deprecated',
        defaultSelection: false,
        fieldDataType: ListDataColumn.TEXT
      }
    }
  ];

  queryConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'soc_code',
      type: 'conditionQueryInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'SOC Code',
        conditionType: OperatorEnum.OperatorEqual
      },
      validators: {
        validation: ['minLengthConditionsForMeddra', 'isNumber']
      }
    },
    {
      className: 'flex-1',
      key: 'soc_name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'SOC Name',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'hlgt_code',
      type: 'conditionQueryInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'HLGT Code',
        conditionType: OperatorEnum.OperatorEqual
      },
      validators: {
        validation: ['minLengthConditionsForMeddra', 'isNumber', 'notMultipleValues']
      }
    },
    {
      className: 'flex-1',
      key: 'hlgt_name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'HLGT Name',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'hlt_code',
      type: 'conditionQueryInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'HLT Code',
        conditionType: OperatorEnum.OperatorEqual
      },
      validators: {
        validation: ['minLengthConditionsForMeddra', 'isNumber', 'notMultipleValues']
      }
    },
    {
      className: 'flex-1',
      key: 'hlt_name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'HLT Name',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'pt_code',
      type: 'conditionQueryInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'PT Code',
        conditionType: OperatorEnum.OperatorEqual
      },
      validators: {
        validation: ['minLengthConditionsForMeddra', 'isNumber', 'notMultipleValues']
      }
    },
    {
      className: 'flex-1',
      key: 'pt_name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'PT Name',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'llt_code',
      type: 'conditionQueryInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'LLT Code',
        conditionType: OperatorEnum.OperatorEqual
      },
      validators: {
        validation: ['minLengthConditionsForMeddra', 'isNumber', 'notMultipleValues']
      }
    },
    {
      className: 'flex-1',
      key: 'llt_name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryConditions'],
        label: 'LLT Name',
        isfreetext: true 
      }
    }

  ];


  hlgtFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'code',
      type: 'input',
      props: {
        disabled: true,
        label: 'HLGT code'
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'input',
      props: {
        disabled: true,
        label: 'HLGT name'
      }
    }
  ];


  hltFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'code',
      type: 'input',
      props: {
        disabled: true,
        label: 'HLT code'
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'input',
      props: {
        disabled: true,
        label: 'HLT name'
      }
    }
  ];

  ptFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'code',
      type: 'input',
      props: {
        disabled: true,
        label: 'PT Code'
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'input',
      props: {
        disabled: true,
        label: 'PT Name'
      }
    }
  ];

  lltFields: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'code',
      type: 'input',
      props: {
        disabled: true,
        label: 'LLT code'
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'input',
      props: {
        disabled: true,
        label: 'LLT name'
      }
    },
    {
      className: 'flex-1',
      key: 'lltDeprecated',
      type: 'input',
      props: {
        disabled: true,
        label: 'Is Deprecated'
      }
    }
  ];

  
}